import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { FinalTaxesAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesAsset';
import { ResidenceType } from '@/modules/asset/enums/ResidenceType';

export class FinalTaxesRealEstateAsset extends FinalTaxesAsset {
  type?: string;
  marketValue?: number;
  purchasePrice?: number;
  cca?: number;
  rollOver?: boolean;

  constructor(model: Partial<FinalTaxesRealEstateAsset> = {}) {
    super(model);

    this.type = model.type ?? '';
    this.marketValue = model.marketValue ?? 0;
    this.purchasePrice = model.purchasePrice ?? 0;
    this.cca = model.cca ?? 0;
    this.rollOver = model.rollOver ?? false;
  }

  getModelName(): ModelType {
    return ModelType.FINAL_TAXES_REAL_ESTATE_ASSET;
  }

  get formattedType(): string {
    return ResidenceType.getByKey(this.type)?.value ?? '';
  }
  get formattedCca(): string {
    return this.formattedCurrencyValue(this.cca);
  }
}
